import request from '@/utils/analyticsRequest'

export function getWorldmap() {
  return request({ url: '/api/v1/analytics/worldmap', method: 'get' })
}

export function getSealpro() {
  return request({ url: '/api/v1/analytics/sealpro', method: 'get' })
}

export function getRecentActivity(params = {}) {
  return request({ url: '/api/v1/analytics/recent-activity', method: 'get', params })
}


export function getLeaderboard(params = {}) {
  return request({ url: '/api/v1/analytics/leaderboard', method: 'get', params })
}
